import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ParentPatrolPlatformFlagsService } from '../services/parent-patrol-platform-flags.service';

/** Parent `/patrol` — requires at least one global platform flag (`patrol.discord` or `patrol.roblox`). */
export const parentPatrolEnabledGuard: CanActivateFn = async () => {
  const flags = inject(ParentPatrolPlatformFlagsService);
  const router = inject(Router);

  await flags.whenReady();

  if (flags.isAnyEnabled()) {
    return true;
  }

  return router.createUrlTree(['/home']);
};
